import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { HerracContext } from "../../App";

function BusForm({ additionalAttributes, setAdditionalAttributes, subCategoryId }) {
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [filteredModels, setFilteredModels] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");
  const { fuelTypeData } = useContext(HerracContext);

  // Debug logging
  useEffect(() => {
    console.log('🚌 BusForm mounted with subCategoryId:', subCategoryId);
    console.log('📋 Current additionalAttributes:', additionalAttributes);
  }, [subCategoryId, additionalAttributes]);

  useEffect(() => {
    if (subCategoryId) {
      console.log('📦 Fetching brands for buses...');
      axios.get(`https://api.herracim.az/api/Brand/BySubCategoryId?subCategoryId=${subCategoryId}`)
        .then(response => {
          console.log('✅ Brands loaded:', response.data.length, 'items');
          setFilteredBrands(response.data);
          setFilteredModels([]);
        })
        .catch(error => {
          console.error('❌ Error loading brands:', error);
          setFilteredBrands([]);
        });
    } else {
      setFilteredBrands([]);
      setFilteredModels([]);
    }
  }, [subCategoryId]);

  useEffect(() => {
    if (selectedBrand) {
      console.log('📦 Fetching models for brand:', selectedBrand);
      axios.get(`https://api.herracim.az/api/Model/ByBrandId?brandId=${selectedBrand}`)
        .then(response => {
          console.log('✅ Models loaded:', response.data.length, 'items');
          setFilteredModels(response.data);
        })
        .catch(error => {
          console.error('❌ Error loading models:', error);
          setFilteredModels([]);
        });
    } else {
      setFilteredModels([]);
    }
  }, [selectedBrand]);

  const handleBrandChange = (e) => {
    const brandId = e.target.value;
    console.log('🏷️ Brand selected:', brandId);
    
    setSelectedBrand(brandId);
    setAdditionalAttributes({
      ...additionalAttributes,
      brandId: brandId,
      modelId: ""
    });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    console.log(`🔧 Field changed: ${name} = ${value}`);
    
    setAdditionalAttributes({
      ...additionalAttributes,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const years = Array.from({ length: new Date().getFullYear() - 1979 }, (_, i) => 1980 + i).reverse();

  return (
    <div className="busForm">
      <div>
        <h3>
          Marka <span>*</span>
          <span className="tooltip-icon" title="Avtobus istehsalçısı">ℹ️</span>
        </h3>
        <select 
          name="brandId" 
          onChange={handleBrandChange} 
          required
          disabled={filteredBrands.length === 0}
          defaultValue=""
        >
          <option value="" disabled>
            {filteredBrands.length === 0 ? 'Yüklənir...' : 'Seçin'}
          </option>
          {filteredBrands.map((brand) => (
            <option key={brand.id} value={brand.id}>{brand.name}</option>
          ))}
        </select>
      </div>

      <div>
        <h3>
          Model <span>*</span>
          <span className="tooltip-icon" title="Avtobus modeli">ℹ️</span>
        </h3>
        <select 
          name="modelId" 
          onChange={handleChange} 
          required
          disabled={filteredModels.length === 0}
          defaultValue=""
        >
          <option value="" disabled>
            {selectedBrand ? (filteredModels.length === 0 ? 'Yüklənir...' : 'Seçin') : 'Əvvəlcə marka seçin'}
          </option>
          {filteredModels.map((model) => (
            <option key={model.id} value={model.id}>{model.name}</option>
          ))}
        </select>
      </div>

      <div>
        <h3>
          İstehsal ili <span>*</span>
          <span className="tooltip-icon" title="Buraxılış ili">ℹ️</span>
        </h3>
        <select name="year" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          {years.map(year => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>
      </div>

      <div>
        <h3>
          Yanacaq növü <span>*</span>
          <span className="tooltip-icon" title="Mühərrik yanacağı">ℹ️</span>
        </h3>
        <select name="fuelTypeId" onChange={handleChange} required defaultValue="">
          <option value="" disabled>Seçin</option>
          {fuelTypeData.map(f => <option key={f.id} value={f.id}>{f.name}</option>)}
        </select>
      </div>

      <div>
        <h3>
          Motor gücü (HP) <span>*</span>
          <span className="tooltip-icon" title="Horsepower">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="horsePower" 
          placeholder="300"
          min="100"
          max="800"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Mühərrik gücü (a.g.) <span>*</span>
          <span className="tooltip-icon" title="At gücü">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="enginePower" 
          placeholder="300"
          min="100"
          max="800"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Mühərrik həcmi (L) <span>*</span>
          <span className="tooltip-icon" title="Engine displacement">ℹ️</span>
        </h3>
        <input 
          type="number" 
          step="0.1"
          name="engineVolume" 
          placeholder="10.0"
          min="5"
          max="20"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Sürət qutusu <span>*</span>
          <span className="tooltip-icon" title="Transmissiya tipi">ℹ️</span>
        </h3>
        <select name="transmission" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Avtomat">Avtomat (Automatic)</option>
          <option value="Mexanik">Mexanik (Manual)</option>
          <option value="Robot">Robot</option>
        </select>
      </div>

      <div>
        <h3>
          Ötürücü tipi <span>*</span>
          <span className="tooltip-icon" title="Drive type">ℹ️</span>
        </h3>
        <select name="driveType" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Ön">Ön (Front)</option>
          <option value="Arxa">Arxa (Rear)</option>
          <option value="Tam">Tam (4x4)</option>
        </select>
      </div>

      <div>
        <h3>
          Rəng <span>*</span>
          <span className="tooltip-icon" title="Kuzov rəngi">ℹ️</span>
        </h3>
        <input 
          type="text" 
          name="color" 
          placeholder="Ağ, Mavi, Sarı..."
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Oturacaq sayı <span>*</span>
          <span className="tooltip-icon" title="Sərnişin tutumu">ℹ️</span>
        </h3>
        <select name="seatCount" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="20">20-25 nəfər (Mikroavtobus)</option>
          <option value="30">30-35 nəfər</option>
          <option value="45">45-50 nəfər</option>
          <option value="60">60+ nəfər</option>
        </select>
      </div>

      <div>
        <h3>
          Qapı sayı <span>*</span>
          <span className="tooltip-icon" title="Giriş qapıları">ℹ️</span>
        </h3>
        <select name="doorCount" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="1">1 qapı</option>
          <option value="2">2 qapı</option>
          <option value="3">3 qapı</option>
        </select>
      </div>

      <div>
        <h3>
          Kondisioner <span>*</span>
          <span className="tooltip-icon" title="A/C sistemi">ℹ️</span>
        </h3>
        <select name="airConditioning" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Var ✅</option>
          <option value="false">Yox ❌</option>
        </select>
      </div>

      <div>
        <h3>
          Yeni <span>*</span>
          <span className="tooltip-icon" title="0 km yenidirmi?">ℹ️</span>
        </h3>
        <select name="isNew" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli (0 km)</option>
          <option value="false">Xeyr (İşlənmiş)</option>
        </select>
      </div>

      <div>
        <h3>
          Qəzalı olub? <span>*</span>
          <span className="tooltip-icon" title="Qəza keçirib?">ℹ️</span>
        </h3>
        <select name="isAccidented" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli ⚠️</option>
          <option value="false">Xeyr ✅</option>
        </select>
      </div>

      <div>
        <h3>
          Sığortası var? <span>*</span>
          <span className="tooltip-icon" title="Insurance">ℹ️</span>
        </h3>
        <select name="hasInsurance" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli ✅</option>
          <option value="false">Xeyr ❌</option>
        </select>
      </div>

      <div>
        <h3>
          Texniki baxışdan keçib? <span>*</span>
          <span className="tooltip-icon" title="Technical inspection">ℹ️</span>
        </h3>
        <select name="hasTechnicalInspection" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli ✅</option>
          <option value="false">Xeyr ❌</option>
        </select>
      </div>

      <div>
        <h3>
          Sahib sayı <span>*</span>
          <span className="tooltip-icon" title="Neçənci sahibdir?">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="ownerCount" 
          min="0" 
          max={10}
          placeholder="1"
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          VIN nömrəsi <span>*</span>
          <span className="tooltip-icon" title="17 simvollu unikal kod">ℹ️</span>
        </h3>
        <input 
          type="text" 
          name="vin" 
          placeholder="1HGBH41JXMN109186"
          maxLength={17}
          onChange={handleChange} 
          required
        />
      </div>

      <div>
        <h3>
          Bazar ölkəsi <span>*</span>
          <span className="tooltip-icon" title="Hansı bazar üçün istehsal olunub">ℹ️</span>
        </h3>
        <select name="marketCountry" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Avropa">Avropa</option>
          <option value="Çin">Çin</option>
          <option value="Rusiya">Rusiya</option>
          <option value="Türkiyə">Türkiyə</option>
          <option value="Amerika">Amerika (ABŞ)</option>
          <option value="Digər">Digər</option>
        </select>
      </div>
    </div>
  );
}

export default BusForm;